import { DataBean } from "../DataBean";

export class RawMaterialManufacturing extends DataBean {


    public async getRawMaterialCatalog(idManufacturingStardard:any,idProduct:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getRawMaterialCatalog_Number_Number", [idManufacturingStardard,idProduct]);
    }

    public async setQuantityToRawMaterial(idRawMaterial:any,idProductVariant:any,quantity:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.productionorders.ManufacturingStardardValue_setQuantityToRawMaterial_Number_Number_Number", [idRawMaterial,idProductVariant,quantity]);
    }
    

 
}